import {
  BAIVIET_COUNT_ASSIGN_SUCCESS,
  BAIVIET_HISTORY_LIST_SUCCESS,
  BAIVIET_IMPORT_SUCCESS,
  BAIVIET_LIST_SUCCESS,
  BAIVIET_NEW_CARE_SUCCESS,
  BAIVIET_ONE_SUCCESS,
  BAIVIET_UPDATE_FILTER,

  BAIVIET_UPDATE_HOMEPAGE_FILTER,
  BAIVIET_HOMEPAGE_LIST_SUCCESS,
  BAIVIET_HOMEPAGE_ONE_SUCCESS,

  BAIVIET_LIMIT_UPDATE_HOMEPAGE_FILTER,
  BAIVIET_LIMIT_HOMEPAGE_LIST_SUCCESS,
  BAIVIET_LIMIT_HOMEPAGE_ONE_SUCCESS,

  BAIVIET_KHONG_NOI_BAT_LIMIT_UPDATE_HOMEPAGE_FILTER,
  BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_LIST_SUCCESS,
  BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_ONE_SUCCESS,
  
  TINTUC_UPDATE_HOMEPAGE_FILTER,
  TINTUC_HOMEPAGE_LIST_SUCCESS,
  TINTUC_HOMEPAGE_ONE_SUCCESS,
} from 'src/actions/baiviet.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },

  homepageBaivietFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageBaivietPage: 0,
    homepageBaivietLimit: DEFAULT_ROW_PER_PAGE,
  },

  homepageBaivietLimitFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageBaivietLimitPage: 0,
    homepageBaivietLimitLimit: DEFAULT_ROW_PER_PAGE,
  },

  homepageBaivietKhongNoiBatLimitFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageBaivietKhongNoiBatLimitPage: 0,
    homepageBaivietKhongNoiBatLimitLimit: DEFAULT_ROW_PER_PAGE,
  },

  homepageTintucFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageTintucPage: 0,
    homepageTintucLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,

  homepageBaivietItems: [],
  homepageBaivietTotal: 0,
  homepageBaivietSelected: undefined,

  homepageBaivietLimitItems: [],
  homepageBaivietLimitTotal: 0,
  homepageBaivietLimitSelected: undefined,

  homepageBaivietKhongNoiBatLimitItems: [],
  homepageBaivietKhongNoiBatLimitTotal: 0,
  homepageBaivietKhongNoiBatLimitSelected: undefined,

  homepageTintucItems: [],
  homepageTintucTotal: 0,
  homepageTintucSelected: undefined,

  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const baivietReducer = (state = initState, action) => {
  switch (action.type) {
    case BAIVIET_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case BAIVIET_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case BAIVIET_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }

    //==========

    case BAIVIET_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageBaivietFilter !== 'undefined' && state.homepageBaivietFilter) {
        if (action.data.homepageBaivietPage == 'no_update' && typeof state.homepageBaivietFilter.homepageBaivietPage !== 'undefined') action.data.homepageBaivietPage = state.homepageBaivietFilter.homepageBaivietPage;
        if (action.data.homepageBaivietLimit == 'no_update' && typeof state.homepageBaivietFilter.homepageBaivietLimit !== 'undefined') action.data.homepageBaivietLimit = state.homepageBaivietFilter.homepageBaivietLimit;
      }
      return {
        ...state,
        homepageBaivietFilter: action.data,
      }
    }
    case BAIVIET_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageBaivietItems: action.data.homepageBaivietItems,
        homepageBaivietTotal: action.data.homepageBaivietTotal,
      }
    }
    case BAIVIET_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageBaivietSelected: action.data
      }
    }

    //==========

    case BAIVIET_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageBaivietLimitFilter !== 'undefined' && state.homepageBaivietLimitFilter) {
        if (action.data.homepageBaivietLimitPage == 'no_update' && typeof state.homepageBaivietLimitFilter.homepageBaivietLimitPage !== 'undefined') action.data.homepageBaivietLimitPage = state.homepageBaivietLimitFilter.homepageBaivietLimitPage;
        if (action.data.homepageBaivietLimitLimit == 'no_update' && typeof state.homepageBaivietLimitFilter.homepageBaivietLimitLimit !== 'undefined') action.data.homepageBaivietLimitLimit = state.homepageBaivietLimitFilter.homepageBaivietLimitLimit;
      }
      return {
        ...state,
        homepageBaivietLimitFilter: action.data,
      }
    }
    case BAIVIET_LIMIT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageBaivietLimitItems: action.data.homepageBaivietLimitItems,
        homepageBaivietLimitTotal: action.data.homepageBaivietLimitTotal,
      }
    }
    case BAIVIET_LIMIT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageBaivietLimitSelected: action.data
      }
    }

    //==========

    case BAIVIET_KHONG_NOI_BAT_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageBaivietKhongNoiBatLimitFilter !== 'undefined' && state.homepageBaivietKhongNoiBatLimitFilter) {
        if (action.data.homepageBaivietKhongNoiBatLimitPage == 'no_update' && typeof state.homepageBaivietKhongNoiBatLimitFilter.homepageBaivietKhongNoiBatLimitPage !== 'undefined') action.data.homepageBaivietKhongNoiBatLimitPage = state.homepageBaivietKhongNoiBatLimitFilter.homepageBaivietKhongNoiBatLimitPage;
        if (action.data.homepageBaivietKhongNoiBatLimitLimit == 'no_update' && typeof state.homepageBaivietKhongNoiBatLimitFilter.homepageBaivietKhongNoiBatLimitLimit !== 'undefined') action.data.homepageBaivietKhongNoiBatLimitLimit = state.homepageBaivietKhongNoiBatLimitFilter.homepageBaivietKhongNoiBatLimitLimit;
      }
      return {
        ...state,
        homepageBaivietKhongNoiBatLimitFilter: action.data,
      }
    }
    case BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageBaivietKhongNoiBatLimitItems: action.data.homepageBaivietKhongNoiBatLimitItems,
        homepageBaivietKhongNoiBatLimitTotal: action.data.homepageBaivietKhongNoiBatLimitTotal,
      }
    }
    case BAIVIET_KHONG_NOI_BAT_LIMIT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageBaivietKhongNoiBatLimitSelected: action.data
      }
    }

    //==========
    
    case TINTUC_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageTintucFilter !== 'undefined' && state.homepageTintucFilter) {
        if (action.data.homepageTintucPage == 'no_update' && typeof state.homepageTintucFilter.homepageTintucPage !== 'undefined') action.data.homepageTintucPage = state.homepageTintucFilter.homepageTintucPage;
        if (action.data.homepageTintucLimit == 'no_update' && typeof state.homepageTintucFilter.homepageTintucLimit !== 'undefined') action.data.homepageTintucLimit = state.homepageTintucFilter.homepageTintucLimit;
      }
      return {
        ...state,
        homepageTintucFilter: action.data,
      }
    }
    case TINTUC_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageTintucItems: action.data.homepageTintucItems,
        homepageTintucTotal: action.data.homepageTintucTotal,
      }
    }
    case TINTUC_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageTintucSelected: action.data
      }
    }

    //==========
    
    case BAIVIET_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case BAIVIET_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case BAIVIET_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case BAIVIET_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default baivietReducer